export const rubrosHistoricos = [
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2024/primer_trimestre2024.zip"
            },{
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2024/segundo_trimestre2024.zip"
            },{
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2024/tercer_trimestre2024.zip"
            },{
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2024/cuarto_trimestre2024.zip"
            }
        ]
    },{
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2023/primer_trimestre2023.zip"
            },{
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2023/segundo_trimestre2023.zip"
            },{
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2023/tercer_trimestre2023.zip"
            },{
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2023/cuarto_trimestre2023.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2022/primer_trimestre2022.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2022/segundo_trimestre2022.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2022/tercer_trimiestre2022.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2022/cuarto_trimestre2022.zip"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/zip/2021/primer_trimistre2021.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/zip/2021/segundo_trimistre2021.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/zip/2021/tercer_trimestre2021.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/zip/2021/cuarto_trimestre2021.zip"
            }
        ]
    }
]